import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file 消息提示
 * @author cynthiawu
 * @description API message.success(content, [duration], onClose, config)
 */
import _ from 'lodash';
import { message } from '@tencent/spaui';
import { PREFIX_CLS } from '../../constants';
import './index.css';
import classNames from 'classnames';
;
var prefixCls = "".concat(PREFIX_CLS, "-message");
var DURATION_DELAY = 2000; // 消息消失到删除节点延时

var api = {}; // message 和 SPAUI message不同的type映射

var messageMap = {
  warning: 'warn'
};
/**
 * Config Params
 */

;

var updateMsgConfig = function updateMsgConfig(otherConfig, propClsName) {
  // UI样式
  var uiType = _.get(otherConfig, 'size', '');

  var uiClsName = classNames(_defineProperty({}, "message-ui-".concat(uiType), !!uiType), propClsName); // message 配置

  message.config(_objectSpread(_objectSpread({}, otherConfig), {}, {
    portalClassName: classNames(prefixCls, uiClsName)
  }));
};

['success', 'info', 'warning', 'error', 'loading', 'strongwarn'].forEach(function (type) {
  api[type] = function (content) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DURATION_DELAY;
    var onClose = arguments.length > 2 ? arguments[2] : undefined;
    var noticeConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var messageType = messageMap[type] || type; // 对象参数

    var isObjectParams = _.isObjectLike(content) && !_.isArray(content); // acttention: 持续时间（duration）单位 - Spaui为秒，此组件为毫秒
    // 对象方式传递的数据

    if (isObjectParams) {
      var _content$duration = content.duration,
          delayTime = _content$duration === void 0 ? DURATION_DELAY : _content$duration,
          propsMsg = content.message,
          _content$portalClassN = content.portalClassName,
          propClsName = _content$portalClassN === void 0 ? '' : _content$portalClassN,
          otherConfig = _objectWithoutProperties(content, ["duration", "message", "portalClassName"]); // message 配置


      updateMsgConfig(otherConfig, propClsName);
      message[messageType](_objectSpread(_objectSpread({
        theme: 'light'
      }, content), {}, {
        message: _.isError(content) ? _.toString(content) : propsMsg,
        duration: delayTime % (1000 * 60) / 1000
      }));
    } else {
      // 解构出配置在config中的数据
      var _noticeConfig$portalC = noticeConfig.portalClassName,
          _propClsName = _noticeConfig$portalC === void 0 ? '' : _noticeConfig$portalC,
          noticeProps = _objectWithoutProperties(noticeConfig, ["portalClassName"]); // message 配置


      updateMsgConfig(noticeProps, _propClsName); // 原始多参数方式

      message[messageType](_objectSpread(_objectSpread({
        theme: 'light'
      }, noticeProps), {}, {
        message: _.toString(content),
        duration: duration % (1000 * 60) / 1000,
        onClose: onClose
      }));
    }
  };
});
export default api;